// @ts-nocheck
export const localeCodes =  [
  "en",
  "en-IE",
  "en-US",
  "en-AU",
  "es",
  "et",
  "nl",
  "fr-CA",
  "it",
  "sl",
  "de",
  "ja",
  "fa",
  "pt",
  "hr",
  "hu"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_45GB_46json_ab8d0470",
      load: () => import("#nuxt-i18n/ab8d0470" /* webpackChunkName: "locale_en_45GB_46json_ab8d0470" */),
      cache: true
    }
  ],
  "en-IE": [
    {
      key: "locale_en_45GB_46json_ab8d0470",
      load: () => import("#nuxt-i18n/ab8d0470" /* webpackChunkName: "locale_en_45GB_46json_ab8d0470" */),
      cache: true
    }
  ],
  "en-US": [
    {
      key: "locale_en_45US_46json_74d77cbb",
      load: () => import("#nuxt-i18n/74d77cbb" /* webpackChunkName: "locale_en_45US_46json_74d77cbb" */),
      cache: true
    }
  ],
  "en-AU": [
    {
      key: "locale_en_45AU_46json_0660441c",
      load: () => import("#nuxt-i18n/0660441c" /* webpackChunkName: "locale_en_45AU_46json_0660441c" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_32334617",
      load: () => import("#nuxt-i18n/32334617" /* webpackChunkName: "locale_es_46json_32334617" */),
      cache: true
    }
  ],
  et: [
    {
      key: "locale_et_45EE_46json_983e324b",
      load: () => import("#nuxt-i18n/983e324b" /* webpackChunkName: "locale_et_45EE_46json_983e324b" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_35b0247d",
      load: () => import("#nuxt-i18n/35b0247d" /* webpackChunkName: "locale_nl_46json_35b0247d" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_9a9983a7",
      load: () => import("#nuxt-i18n/9a9983a7" /* webpackChunkName: "locale_fr_45CA_46json_9a9983a7" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_2ef8f66b",
      load: () => import("#nuxt-i18n/2ef8f66b" /* webpackChunkName: "locale_it_46json_2ef8f66b" */),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46json_cc103cb8",
      load: () => import("#nuxt-i18n/cc103cb8" /* webpackChunkName: "locale_sl_46json_cc103cb8" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_f2b344a5",
      load: () => import("#nuxt-i18n/f2b344a5" /* webpackChunkName: "locale_de_46json_f2b344a5" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_a8d2c341",
      load: () => import("#nuxt-i18n/a8d2c341" /* webpackChunkName: "locale_ja_46json_a8d2c341" */),
      cache: true
    }
  ],
  fa: [
    {
      key: "locale_fa_46json_5d68f915",
      load: () => import("#nuxt-i18n/5d68f915" /* webpackChunkName: "locale_fa_46json_5d68f915" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_5040dd54",
      load: () => import("#nuxt-i18n/5040dd54" /* webpackChunkName: "locale_pt_46json_5040dd54" */),
      cache: true
    }
  ],
  hr: [
    {
      key: "locale_hr_46json_9f185a76",
      load: () => import("#nuxt-i18n/9f185a76" /* webpackChunkName: "locale_hr_46json_9f185a76" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_082c1a3b",
      load: () => import("#nuxt-i18n/082c1a3b" /* webpackChunkName: "locale_hu_46json_082c1a3b" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/c24f973b" /* webpackChunkName: "config_i18n_46config_46ts_c24f973b" */)
]
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-GB",
    name: "English (GB)",
    date: "enGB",
    language: "en-GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB"
  },
  {
    code: "en-IE",
    name: "English (IE)",
    _hreflang: "en-IE",
    _sitemap: "en-IE",
    language: undefined
  },
  {
    code: "en-US",
    name: "English (US)",
    _hreflang: "en-US",
    _sitemap: "en-US",
    language: undefined
  },
  {
    code: "en-AU",
    name: "English (AU)",
    _hreflang: "en-AU",
    _sitemap: "en-AU",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    date: "es",
    _hreflang: "es",
    _sitemap: "es",
    language: undefined
  },
  {
    code: "et",
    name: "Eesti keel (Eesti)",
    _hreflang: "et",
    _sitemap: "et",
    language: undefined
  },
  {
    code: "nl",
    iso: "nl",
    name: "Nederlands",
    language: "nl",
    _hreflang: "nl",
    _sitemap: "nl"
  },
  {
    code: "fr-CA",
    iso: "fr-CA",
    name: "Français (Canadian)",
    language: "fr-CA",
    _hreflang: "fr-CA",
    _sitemap: "fr-CA"
  },
  {
    code: "it",
    iso: "it",
    name: "Italiano",
    language: "it",
    _hreflang: "it",
    _sitemap: "it"
  },
  {
    code: "sl",
    iso: "sl",
    name: "Slovenščina",
    language: "sl",
    _hreflang: "sl",
    _sitemap: "sl"
  },
  {
    code: "de",
    iso: "de",
    name: "Deutsch",
    language: "de",
    _hreflang: "de",
    _sitemap: "de"
  },
  {
    code: "ja",
    iso: "ja",
    intl: "ja.json",
    name: "日本語",
    date: "ja",
    language: "ja",
    _hreflang: "ja",
    _sitemap: "ja"
  },
  {
    code: "fa",
    iso: "fa",
    name: "فارسی",
    dir: "rtl",
    language: "fa",
    _hreflang: "fa",
    _sitemap: "fa"
  },
  {
    code: "pt",
    iso: "pt",
    name: "Português",
    language: "pt",
    _hreflang: "pt",
    _sitemap: "pt"
  },
  {
    code: "hr",
    iso: "hr",
    name: "Hrvatski",
    date: "hr",
    language: "hr",
    _hreflang: "hr",
    _sitemap: "hr"
  },
  {
    code: "hu",
    iso: "hu",
    name: "magyar",
    date: "hu",
    language: "hu",
    _hreflang: "hu",
    _sitemap: "hu"
  }
]
/** client **/

/** client-end **/